import styled from "styled-components";
import globalColors from "../../../../../_metronic/_assets/sass/custom/globalColors.scss";

export const Container = styled.div`
  padding: 16px;

  h2,
  h4,
  p,
  span {
    font-family: "Open Sans";
  }
`;

export const TitleModal = styled.h2`
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  color: ${globalColors.primaryColor3};

  margin-bottom: 4px;
`;

export const TitleCard = styled.h4`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${globalColors.textColor1};

  margin-bottom: 4px;
`;

export const InputCustom = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
`;

export const ModalHeader = styled.div``;

export const Separator = styled.div`
  border-bottom: 1px solid ${globalColors.primaryColor3};
`;

export const ModalBody = styled.div`
  padding: 16px 0;
`;

export const InfoCard = styled.div`
  display: flex;
  flex-direction: column;
  background: ${globalColors.primaryColor1 + "80"};
  border-radius: 4px;
  padding: 8px;
  width: 100%;
`;

export const ContentText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${globalColors.textColor1};

  margin: 0;

  img {
    margin: 0 8px;
  }
`;

export const InfoCard2 = styled.div`
  display: flex;
  gap: 8px;
  background: ${globalColors.colorWhite};
  border-radius: 4px;
  height: 32px;
  align-items: center;
  padding: 8px;
`;

export const Select = styled.select`
  width: 220px;
  height: 32px;

  padding: 0;

  border: none;

  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  text-transform: uppercase;

  padding: 0;

  width: 150px;
  height: 48px;

  background: ${({ submit }) =>
    submit ? globalColors.primaryColor3 : "transparent"};
  color: ${({ submit }) => (submit ? globalColors.colorWhite : globalColors.primaryColor3)};
  border: none;
  border-radius: 4px;

  transition: filter 0.4s;

  &:hover {
    filter: brightness(90%);
    text-decoration: ${({ submit }) => (!submit ? "underline" : "")};
  }
`;
